import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const _groupFixturesByDate = (fixtures) => {
  const groups = {};
  fixtures.forEach((fixture) => {
    const matchDate = new Date(parseInt(fixture.match_date.$date.$numberLong));
    const today = new Date();

    let label;
    if (matchDate.toDateString() === today.toDateString()) {
      label = "Today";
    } else {
      // Format: Thu, Aug 21, 2025
      label = matchDate.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    }

    if (!groups[label]) groups[label] = [];
    groups[label].push(fixture);
  });
  return groups;
};


export const filterFixturesWithOdds = (fixtures) =>
  fixtures.filter((fixture) => {
    if (!Array.isArray(fixture.fixture_markets) || fixture.fixture_markets.length === 0) return false;
    if (!Array.isArray(fixture.fixture_market_count) || fixture.fixture_market_count.length === 0) return false;

    const hasEmptyOdds = fixture.fixture_markets.some(
      (fm) =>
        fm.fixture_bb_id === fixture.bb_id &&
        (!Array.isArray(fm.fixture_market_odds) || fm.fixture_market_odds.length === 0)
    );

    return !hasEmptyOdds;
  })

  // export  const groupedFixtures = (fixtures ?? []).reduce((acc, fixture) => {
  //     const timestamp = Number(fixture?.match_date?.$date?.$numberLong ?? 0);
  //     const dateLabel = formatTimestampToDateLabel(timestamp);
  
  //     if (!acc[dateLabel]) {
  //       acc[dateLabel] = isSportDetails ? {} : [];
  //     }
  
  //     if (isSportDetails) {
  //       // Find matching league from leagues state
  //       const leagueMatch = leagues?.find(
  //         (l) => l === fixture?.tournament_bb_id || l?.id === fixture?.tournament_bb_id
  //       );
  
  //       // If we found the league, pull its info from the fixture's tournament
  //       const leagueInfo = fixture?.tournament;
  //       const leagueName = leagueInfo
  //         ? `${leagueInfo?.category?.name ?? ""}${leagueInfo?.live_category?.name ? ` - ${leagueInfo.live_category.name}` : ""
  //         } - ${leagueInfo?.name ?? ""}`
  //         : "Unknown League";
  
  //       if (!acc[dateLabel][leagueName]) acc[dateLabel][leagueName] = [];
  //       acc[dateLabel][leagueName].push(fixture);
  //     } else {
  //       acc[dateLabel].push(fixture);
  //     }
  
  //     return acc;
  //   }, {});